import moment from 'moment';
import { formatFromToDates } from './formatFromToDates';
import updateRequestMaster from '../requests/updateRequestMaster';
import updateRequestExecuter from '../requests/updateRequestExecuter';
import updateRequestAddress from '../requests/updateRequestAddress';
import updateRequestService from '../requests/updateRequestService';
import updateRequestExecuteTime from '../requests/updateRequestExecuteTime';
import updateWarrantyInfo from '../requests/updateWarrantyInfo';
import addWarrantyDocs from '../requests/addWarrantyDocs';
import updateCalendarEvent from '../requests/updateCalendarEvent';
import deleteCalendarEvent from '../requests/deleteCalendarEvent';
import updateRequestStatus from '../requests/updateRequestStatus';
import addCalendarEvent from '../requests/addCalendarEvent';
import changeRequestCreationMethod from '../requests/changeRequestCreationMethod';
import { changeRequestPriority } from '../requests/changeRequestPriority';

export const requestCardMutationFns = {
  master: ({ values }) => updateRequestMaster(values.request, values.masterId),

  executer: ({ values }) =>
    updateRequestExecuter(values.request, values.executerId),

  address: ({ values }) => {
    const {
      request: requestId,
      addressId,
      executerId: executorId,
      masterId,
      typeId: serviceId,
    } = values;

    const data = {
      addressId,
      executorId,
      masterId,
      serviceId,
    };

    return updateRequestAddress(requestId, data);
  },

  service: ({ values }) =>
    updateRequestService(values.request, values.newServiceId),

  executionTime: ({ values }) => {
    const {
      request: requestId,
      comment: note,
      executeTime,
      executeDate,
    } = values;

    const executeDateStr = executeDate.format('YYYY-MM-DD');
    const executeTimeStr = executeTime.format('HH:mm');

    const executiontDateTime = moment(`${executeDateStr} ${executeTimeStr}`)
      .utc()
      .format();

    const data = { executeDate: executiontDateTime, note };
    return updateRequestExecuteTime(requestId, data);
  },

  warrantyInfo: ({ values }) => updateWarrantyInfo(values.requestId, values),

  warrantyDocs: ({ requestId, values }) => addWarrantyDocs(requestId, values),

  calendarEventAdd: ({ values }) => {
    const {
      executeDate,
      executeTimeEnd,
      executeTimeStart,
      executerId,
      request: requestId,
    } = values;

    const { fromDate, toDate } = formatFromToDates(
      executeDate,
      executeTimeStart,
      executeTimeEnd
    );

    const calendarEvent = {
      requestId,
      workerId: executerId,
      fromDate,
      toDate,
    };

    return addCalendarEvent(calendarEvent);
  },

  calendarEventUpdate: ({ values }) => {
    const {
      eventId,
      executeDate,
      executeTimeEnd,
      executeTimeStart,
      executerId,
      request: requestId,
    } = values;

    const { fromDate, toDate } = formatFromToDates(
      executeDate,
      executeTimeStart,
      executeTimeEnd
    );

    const calendarEvent = {
      requestId,
      workerId: executerId,
      fromDate,
      toDate,
    };

    return updateCalendarEvent(eventId, calendarEvent);
  },

  calendarEventDelete: ({ values }) => deleteCalendarEvent(values.eventId),

  status: ({ request, status }) => updateRequestStatus(request.id, status.id),

  creationMethod: ({ requestId, creationMethod }) =>
    changeRequestCreationMethod({ requestId, methodId: creationMethod.id }),

  priority: ({ requestId, priority }) =>
    changeRequestPriority({ requestId, priorityId: priority.id }),
};
